import React from "react";
import "./Toggle.css";

interface ToggleProps {
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    label?: string;
    /** Render as a non-interactive indicator, for use inside a row that is itself the button. */
    indicator?: boolean;
}

// ON/OFF switch (pure CSS).
const Toggle = ({ checked, onChange, disabled, label, indicator }: ToggleProps) => {
    const content = (
        <>
            <span className="toggle-text">{checked ? 'ON' : 'OFF'}</span>
            <span className="toggle-knob" />
        </>
    );

    if (indicator) {
        return <span className={`toggle-switch ${checked ? 'on' : ''} ${disabled ? 'disabled' : ''}`} aria-hidden="true">{content}</span>;
    }

    return (
        <button
            className={`toggle-switch ${checked ? 'on' : ''}`}
            role="switch"
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange?.(!checked)}
        >
            {content}
        </button>
    );
};

export default Toggle;
